import { Chip, TextField, Tooltip } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { FC, ReactNode, useEffect } from "react";

type InputComboBoxListProperties = {
    id?: string;
    value?: any;
    options: any[];
    label?: string;
    textField: string;
    valueField: string;
    autoComplete?: boolean;
    error?: boolean;
    multiple?: boolean;
    disableClearable?: boolean;
    disabled?: boolean;
    limitTags?: number;
    helperText?: ReactNode;
    renderOptions?: (option: any) => string | JSX.Element;
    renderOptionsLabel?: (option: any) => string
    onChange: (value: any, index?: number) => void
    onBlur?: Function;
    onFocus?: Function;
    optionsDisabled?: any[];
}

const InputComboBoxList: FC<InputComboBoxListProperties> = ({
    id,
    label,
    value,
    options,
    textField,
    disabled = false,
    autoComplete = false,
    error = false,
    disableClearable = false,
    valueField,
    renderOptions,
    renderOptionsLabel,
    limitTags,
    multiple,
    onChange,
    helperText,
    onBlur,
    onFocus,
    optionsDisabled = [],
}) => {
    const [localValue, setLocalValue] = React.useState<any>();
    const [inputValue, setInputValue] = React.useState('');

    useEffect(() => {
        if (!value) {
            setLocalValue(null)
            setInputValue('')
        } else {
            setLocalValue(Array.isArray(value) ? value.map((v) => v[textField]).join(", ") : value);
            setInputValue(value ? renderOptionsLabel ? renderOptionsLabel(value) : value[textField] : "")
        }
    }, [value]);

    return <>
        <Tooltip title={localValue && multiple ? localValue : localValue && renderOptions ? renderOptions(localValue) : ""} >
            <Autocomplete
                getOptionDisabled={(option)=>{
                    return option.value ? optionsDisabled?.includes(option.value) : false;
                }}
                multiple={multiple}
                fullWidth
                id={id}
                value={value}
                disabled={disabled}
                disableClearable={disableClearable}
                options={options}
                limitTags={limitTags}
                autoComplete={autoComplete}
                getOptionLabel={(option) => {
                    return option ? renderOptionsLabel ? renderOptionsLabel(option) : option[textField] : ""
                }}
                getOptionSelected={(option, value) => value ? option[valueField] === value[valueField] : false}
                onChange={(_event, value) => {
                    if (!value) {
                        setLocalValue(null)
                        setInputValue('')
                    }

                    const index = value && value[valueField] ? options.findIndex((o) => o[valueField] === value[valueField]) : -1
                    onChange(value, index)
                }}
                renderOption={(option) => {
                    return renderOptions ? renderOptions(option) : option[textField]
                }}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                        <Chip
                            style={{ margin: "0px 1px 0px 1px" }}
                            size="small"

                            label={option[textField]}
                            {...getTagProps({ index })}
                        />
                    ))
                }
                renderInput={(params) => <TextField
                    {...params}
                    InputLabelProps={{
                        shrink: true
                    }}
                    label={label}
                    variant="outlined"
                    size="small"
                    margin="normal"
                    fullWidth
                    value={inputValue}
                    helperText={helperText}
                    error={error}
                />
                }
                onFocus={(event: any) => {
                    if (onFocus) {
                        onFocus(event)
                    }
                }}
                onBlur={(event: any) => {
                    if (onBlur) {
                        onBlur(event)
                    }
                }}
            />
        </Tooltip>
    </>
}

export { InputComboBoxList }